import Main from '@/layout/index.vue'
export default [

    {
        path: '/',
        name: '_home',
        redirect: '/ztdt',
        component: Main,
        meta: {
            title: '首页',
        },
        children: [
            {
                path: 'ztdt',
                name: 'ztdt',
                meta: {
                    title: '首页',
                },
                component: () => import('@/layout/change.vue')
            },
        ]
    },
    //错误路由定位至采集页面
    { path: '*', redirect: '/ztdt', hidden: true }

]


